module.exports = __webpack_public_path__ + "static/media/youtube.08812de5.svg";